<template>
  <div
    class="company-tag"
    :class="{
      'is-success': item.kind === 0,
      'is-risk': item.kind === 1,
      'is-gray': item.kind === 2
    }"
    @click="handleOpenDetail"
  >
    <template v-if="!isReview">
      <div class="company-tag__title">
        <span class="ellipsis name">{{ item.name }}</span>
        <span v-if="item.recordtime" class="subfix">（{{ item.recordtime }})</span>
        <span v-else class="subfix" style="margin-left: 16px">--</span>
      </div>
      <div class="company-tag__desc">
        <i class="t-iconfont" :class="iconMap[item?.sourceType]" />
        <span class="ellipsis time">{{ item.time || '--' }}</span>
      </div>
    </template>
    <template v-else>
      <div class="company-tag__title">
        <span class="ellipsis name" v-html="addNodeByWX(item.sessionCreatorName)"></span>
        <span v-if="item.recordtime" class="subfix">（{{ item.recordtime }})</span>
        <span v-else class="subfix" style="margin-left: 16px">--</span>
      </div>
      <div class="company-tag__desc">
        <i class="t-iconfont" :class="iconMap[item?.sourceType]" />
        <span class="ellipsis time">{{ item.time }}</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { onMounted, nextTick } from 'vue'
import { addNodeByWX } from '@/utils/wx-node.js'
import { sourceTypeIconMap as iconMap } from '@/constants/source-type-map'

defineOptions({
  name: 'CompanyTag'
})

const props = defineProps({
  item: {
    type: Object,
    default: () => {
      return {}
    }
  },
  isReview: {
    type: Boolean,
    default: false
  },
  isInit: {
    type: Boolean,
    default: false
  },
  isLast: {
    type: Boolean,
    default: false
  },
  activeStageId: {
    type: [String, Number],
    default: ''
  }
})

const emits = defineEmits(['init', 'openDetail'])

const handleOpenDetail = () => {
  emits('openDetail', props.item)
}

onMounted(() => {
  nextTick(() => {
    if (!props.isInit && props.isLast) {
      emits('init')
    }
    if (props.activeStageId === props.item.id) {
      emits('activeStageChange', props.item)
    }
  })
})
</script>

<style lang="scss" scoped>
.company-tag {
  display: flex;
  flex-direction: column;
  width: max-content;
  padding: 8px 12px;
  cursor: pointer;
  background: #c9cdd4;
  border-radius: 4px;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
  .company-tag__title {
    display: flex;
    margin-bottom: 2px;
    white-space: nowrap;
    .name {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
    .subfix {
      flex: 0 0 auto;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 20px;
      color: #ffffff;
    }
  }
  .company-tag__desc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    height: 18px;
    i {
      font-size: 14px;
      margin-right: 5px;
    }
    .time {
      font-size: 13px;
      line-height: 18px;
      text-align: left;
    }
  }

  // 通用省略号样式合并
  .ellipsis {
    flex: 1;
    overflow: hidden;
    font-family: PingFang SC;
    color: #ffffff;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.is-success {
  background: #0fbb54;
}
.is-risk {
  background: #fd5555;
}
.is-gray {
  background: #c9cdd4;
}
.t-iconfont {
  color: #ffffff;
}
</style>
